// /posts 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 6개를 이 배열 하나로 대체한다. field 키 / operator / 옵션값 동일.

import type { SearchFieldConfig } from "components/list";

export const postsSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "title", label: "제목", type: "text", operator: "contains", width: 200 },
  { name: "content", label: "내용", type: "text", operator: "contains", width: 200 },
  {
    name: "boardKind",
    label: "유형",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "NORMAL", label: "이야기" },
      { value: "ALBUM", label: "포토앨범" },
      { value: "AGENDA", label: "알림장" },
      { value: "MEAL", label: "식단표" },
    ],
  },
  { name: "userId", label: "글쓴이ID", type: "text", operator: "contains", width: 160 },
  { name: "boardId", label: "게시판ID", type: "text", operator: "contains", width: 160 },
];
